export enum INVOICE_TYPE {
  PAY_PER_MONTH = 'pay_per_month',
  PAY_PER_CHARGE = 'pay_per_charge',
  PLAN = 'plan',
  FEE = 'Fee'
}
